import { createUserProfileConfig } from "@/static/userProfileConfig";
import { useAuthStore } from "@/store";
import { useNavigate } from "react-router-dom";
import {
  ActionDropdown,
  ActionDropdownContent,
  ActionDropdownTrigger,
} from "./ActionDropdown";

interface UserProfileDropdownProps {
  userName?: string;
  userEmail?: string;
  profilePhotoUrl?: string | null;
}

const UserProfileDropdown = ({
  userName = "Super Admin",
  userEmail = "admin@college.edu",
  profilePhotoUrl,
}: UserProfileDropdownProps) => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const userProfileConfig = createUserProfileConfig(navigate, logout);

  // Get initials for avatar
  const initials = userName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <ActionDropdown menuModal={false}>
      <ActionDropdownTrigger
        triggerContent={
          <div className="flex items-center gap-3">
            <div className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-tr from-indigo-600 to-violet-600 text-sm font-black text-white shadow-lg shadow-indigo-100 ring-4 ring-white overflow-hidden">
              {profilePhotoUrl ? (
                <img 
                  src={profilePhotoUrl} 
                  alt={userName} 
                  className="h-full w-full object-cover"
                />
              ) : (
                initials
              )}
            </div>
            <div className="hidden min-w-0 max-w-[150px] flex-col items-start md:flex lg:max-w-[200px]">
              <span className="w-full truncate text-sm font-black text-slate-800">
                {userName}
              </span>
              <span className="text-indigo-600/60 w-full truncate text-[10px] font-bold uppercase tracking-wider">
                {userEmail}
              </span>
            </div>
          </div>
        }
        buttonVariant="ghost"
        buttonSize="default"
        ariaLabel="User profile menu"
        className={{
          buttonClass: "h-auto px-2 py-1.5",
        }}
      />
      <ActionDropdownContent
        align="end"
        sideOffset={8}
        dropdownShape={userProfileConfig}
        className="w-56"
      />
    </ActionDropdown>
  );
};

export default UserProfileDropdown;
